// ssrc/features/townBudget/components/programs/Program_LicensesAndPermits.jsx

import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

/**
 * Town Program: Licenses & Permits
 *
 * Firestore docId should match your stored doc:
 *   revenues_licenses_permits
 */
export const PROGRAM_LICENSES_AND_PERMITS_CONFIG = {
  fullName: "Licenses & Permits",
  docId: "revenues_licenses_permits",

  fieldDefs: [
    {
      key: "buildingInspectionFees",
      label: "Building Inspection Fees",
      valueType: "currency",
      sources: [{ block: "Licenses & Permits", key: "Building Inspection Fees" }],
      group: "permits",
      defaultVisible: true,
    },
    {
      key: "townClerkFees",
      label: "Town Clerk Fees",
      valueType: "currency",
      sources: [{ block: "Licenses & Permits", key: "Town Clerk Fees" }],
      group: "townClerk",
      defaultVisible: true,
    },
    {
      key: "physicalServicesFees",
      label: "Physical Services Fees",
      valueType: "currency",
      sources: [{ block: "Licenses & Permits", key: "Physical Services Fees" }],
      group: "publicWorks",
      defaultVisible: false,
    },
    {
      key: "refusePermitFees",
      label: "Refuse Permit Fees",
      valueType: "currency",
      sources: [{ block: "Licenses & Permits", key: "Refuse Permit Fees" }],
      group: "publicWorks",
      defaultVisible: true,
    },
    {
      key: "health",
      label: "Health",
      valueType: "currency",
      sources: [{ block: "Licenses & Permits", key: "Health" }],
      group: "healthSafety",
      defaultVisible: true,
    },
    {
      key: "fireMarshal",
      label: "Fire Marshal",
      valueType: "currency",
      sources: [{ block: "Licenses & Permits", key: "Fire Marshal" }],
      group: "healthSafety",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "adopted",
      title: "Licenses & Permits – Approved",
      sectionKey: "Approved",
      fields: [
        "buildingInspectionFees",
        "townClerkFees",
        "physicalServicesFees",
        "refusePermitFees",
        "health",
        "fireMarshal",
      ],
      columnStyles: {
        year: { width: "90px", minWidth: "90px" },
        buildingInspectionFees: { minWidth: "180px" },
        townClerkFees: { minWidth: "140px" },
        physicalServicesFees: { minWidth: "160px" },
        refusePermitFees: { minWidth: "150px" },
        health: { minWidth: "110px" },
        fireMarshal: { minWidth: "120px" },
      },
    },
    {
      id: "actual",
      title: "Licenses & Permits – Actual",
      sectionKey: "Actual",
      fields: [
        "buildingInspectionFees",
        "townClerkFees",
        "physicalServicesFees",
        "refusePermitFees",
        "health",
        "fireMarshal",
      ],
      columnStyles: {
        year: { width: "90px", minWidth: "90px" },
        buildingInspectionFees: { minWidth: "180px" },
        townClerkFees: { minWidth: "140px" },
        physicalServicesFees: { minWidth: "160px" },
        refusePermitFees: { minWidth: "150px" },
        health: { minWidth: "110px" },
        fireMarshal: { minWidth: "120px" },
      },
    },
  ],

  chartTitle: "Licenses & Permits",
};

export function ProgramLicensesAndPermits(props) {
  return (
    <ProgramBudget
      programId="revenues_licenses_permits"
      config={PROGRAM_LICENSES_AND_PERMITS_CONFIG}
      {...props}
    />
  );
}
